import { ClientBillingPackage } from '../types/Billing';
import { PackageFeatures } from './../enums/Billing';

export function hasPackageFeature(
    clientPackage: ClientBillingPackage | undefined,
    feature: PackageFeatures,
): boolean {
    if (!clientPackage) {
        return false;
    }
    return feature in clientPackage.features;
}
